import { useEffect } from "react";
import { ArrowRight, ArrowLeft, Printer, Loader2, Check, FileText } from "lucide-react";

export const PrintPhase = ({ labels, previews, loadPreview, onPrint, printing, printed, onZoom, onBack, onNext }) => {
  useEffect(() => {
    labels.forEach((l) => { if (!previews[l.id]) loadPreview(l.id); });
    // eslint-disable-next-line
  }, [labels]);

  return (
    <div className="space-y-4" data-testid="print-phase">
      <div>
        <p className="text-base font-semibold text-white/90">Print the shipping labels</p>
        <p className="text-xs text-white/40 mt-0.5">Each label prints with its SKU on it. Tap a label to zoom.</p>
      </div>

      <button
        onClick={onPrint}
        disabled={printing || labels.length === 0}
        className={`w-full flex items-center justify-center gap-2.5 py-5 rounded-2xl text-lg font-bold transition-colors disabled:opacity-40 ${
          printed ? "bg-[#10B981]/15 border border-[#10B981]/40 text-[#10B981]" : "bg-[#00D4FF] text-[#0a0a14] hover:bg-[#00bfe6]"
        }`}
        data-testid="print-labels-btn"
      >
        {printing ? <Loader2 className="w-6 h-6 animate-spin" /> : printed ? <Check className="w-6 h-6" /> : <Printer className="w-6 h-6" />}
        {printing ? "Preparing labels..." : printed ? `Printed ${labels.length} labels — print again` : `Print ${labels.length} Label${labels.length === 1 ? "" : "s"}`}
      </button>

      {labels.length === 0 ? (
        <p className="text-sm text-white/30 text-center py-8">No shipping labels were added for this pull list</p>
      ) : (
        <div className="grid grid-cols-2 gap-3" data-testid="label-grid">
          {labels.map((label) => (
            <button
              key={label.id}
              onClick={() => previews[label.id] && onZoom(previews[label.id])}
              className="rounded-xl overflow-hidden border border-white/[0.08] bg-white/[0.03] text-left active:scale-[0.98] transition-transform"
              data-testid={`label-card-${label.id}`}
            >
              <div className="aspect-[2/3] bg-white/[0.04] flex items-center justify-center">
                {previews[label.id] ? (
                  <img src={previews[label.id]} alt="Label" className="w-full h-full object-contain" />
                ) : previews[label.id] === null ? (
                  <FileText className="w-8 h-8 text-white/20" />
                ) : (
                  <Loader2 className="w-5 h-5 text-white/30 animate-spin" />
                )}
              </div>
              <div className="p-2.5">
                <p className="text-xl font-black tracking-wide text-[#FF6B35]" data-testid={`label-sku-${label.id}`}>
                  {label.sku_tag || <span className="text-white/30 text-sm font-medium">No SKU</span>}
                </p>
                <p className="text-[11px] text-white/45 truncate">{label.display_name || label.filename}</p>
                {label.note && <p className="text-[10px] text-white/35 truncate">{label.note}</p>}
              </div>
            </button>
          ))}
        </div>
      )}

      <div className="fixed bottom-0 left-0 right-0 p-4 bg-gradient-to-t from-[#0a0a14] via-[#0a0a14] to-transparent flex gap-2">
        <button onClick={onBack} className="px-4 py-4 rounded-xl bg-white/[0.06] border border-white/10 text-white/70" data-testid="print-back-btn">
          <ArrowLeft className="w-5 h-5" />
        </button>
        <button
          onClick={onNext}
          className={`flex-1 flex items-center justify-center gap-2 py-4 rounded-xl text-base font-semibold transition-colors ${
            printed ? "bg-[#10B981] text-white hover:bg-[#059669]" : "bg-white/[0.08] border border-white/15 text-white/80 hover:bg-white/[0.12]"
          }`}
          data-testid="print-next-btn"
        >
          Next: Pack & Ship
          <ArrowRight className="w-5 h-5" />
        </button>
      </div>
    </div>
  );
};
